export default __webpack_public_path__ + "static/media/location.336cd7be.png";